export default __webpack_public_path__ + "static/media/black_friday_dashboard_slide2.6cd307b8.png";